export default "__VITE_ASSET__0c17cfc1__"